import { Observable } from 'rxjs/Observable';
import { BaseCardConfiguration } from 'app/core/components/workflow-new/common/base-card-configuration';

export class CardConfiguration extends BaseCardConfiguration{
    hideInstructor:boolean;
    hideLocation: boolean;
    hideStatus: boolean;    
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/course/configurations/card-configuration.ts